import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "Yvooa-Core",
  storage: sessionStorage,
});

export const clientUiSettings = atom({
  key: "clientUiSettings",
  default: {
    sideNavbarEnabled: true,
  },
  effects_UNSTABLE: [persistAtom],
});
